import React from 'react';
import PropTypes from 'prop-types';
import { PupAvatar } from '@web/components';
import {
  StyledConfirmationHero,
  AvatarsContainer,
  Avatar,
  Header,
  Subheader,
  Date,
} from './styles.js';

export const ConfirmationHero = ({ pets, customerName, deliveryDate }) => {
  const petNames = [];
  const petBreeds = [];
  for (let count = 0; count < pets.length; count++) {
    petNames.push(pets[count]?.name);
    petBreeds.push(pets[count]?.breeds);
  }

  const getListOfNames = () => {
    let listOfNames = '';

    const lastPetName = petNames.pop();

    if (!petNames?.length) {
      listOfNames = `${lastPetName}'s`;
    } else {
      listOfNames = `${petNames.join(', ')}, and ${lastPetName}'s`;
    }

    return listOfNames;
  };

  return (
    <StyledConfirmationHero>
      <AvatarsContainer>
        {petBreeds.map((breeds, index) => (
          <Avatar key={index}>
            <PupAvatar breeds={breeds} />
          </Avatar>
        ))}
      </AvatarsContainer>
      <Header>Thanks for your purchase, {customerName}!</Header>
      <Subheader>
        {getListOfNames()} starter box is estimated to arrive on{' '}
        <Date>{deliveryDate}</Date>.
      </Subheader>
    </StyledConfirmationHero>
  );
};
ConfirmationHero.displayName = 'ConfirmationHero';
ConfirmationHero.propTypes = {
  pets: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      breeds: PropTypes.arrayOf(PropTypes.string.isRequired),
    }),
  ).isRequired,
  customerName: PropTypes.string.isRequired,
  deliveryDate: PropTypes.string.isRequired,
};
